
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.666 8a2.672 2.672 0 00-2.667-2.667A2.672 2.672 0 005.333 8a2.672 2.672 0 002.666 2.667A2.672 2.672 0 0010.666 8zm1.437 0A4.099 4.099 0 018 12.104 4.099 4.099 0 013.895 8 4.099 4.099 0 018 3.896 4.099 4.099 0 0112.103 8zm1.126-4.27a.956.956 0 01-.958.957.956.956 0 01-.958-.958c0-.53.427-.958.958-.958.53 0 .958.428.958.958zm-5.23-2.293c-1.166 0-3.666-.094-4.718.323a2.558 2.558 0 00-.917.604 2.55 2.55 0 00-.604.917c-.417 1.052-.323 3.552-.323 4.718 0 1.167-.094 3.667.323 4.719.146.365.323.635.604.917.281.281.552.458.917.604 1.052.416 3.552.322 4.718.322 1.167 0 3.667.094 4.719-.322.365-.146.635-.323.917-.604.281-.282.458-.552.604-.917.416-1.052.322-3.552.322-4.719 0-1.166.094-3.666-.322-4.718a2.558 2.558 0 00-.604-.917 2.549 2.549 0 00-.917-.604c-1.052-.417-3.552-.323-4.719-.323zM16 8c0 1.104.011 2.198-.052 3.302-.062 1.281-.354 2.417-1.291 3.354-.937.937-2.073 1.23-3.354 1.291C10.198 16.01 9.104 16 8 16s-2.198.011-3.302-.052c-1.281-.062-2.417-.354-3.354-1.291-.937-.937-1.23-2.073-1.291-3.354C-.01 10.198 0 9.104 0 8S-.01 5.802.053 4.698c.062-1.281.354-2.417 1.291-3.354C2.281.407 3.417.114 4.698.053 5.802-.01 6.896 0 8 0s2.198-.011 3.302.052c1.281.062 2.417.354 3.354 1.291.937.937 1.23 2.073 1.291 3.354C16.01 5.802 16 6.896 16 8z","fill":"currentColor"}})])
          )
        }
      }
    